import '../../style/index.less';
import './index.less';

// style dependencies
import '../../select/style';
import '../../checkbox/style';



// WEBPACK FOOTER //
// ./_antd1.11.2/tree-select/style/index.js